import React from 'react';
import { isEmpty } from 'lodash';

import {
  Switch,
  Route,
  Redirect
} from 'react-router-dom';

import { useFormContext } from './context/formContext';
import Maintenance from './pages/maintenance';
import Checkout from './pages/checkout';
import Confirmation from './pages/confirmation';
import { HVAC_MONITORING } from './utils/const.js.erb';

const Routes = () => {
  const {
    service,
    user,
    address,
    quote,
    order,
    isLoading,
    errorMessage,
    startLoading,
    stopLoading,
    updateFormInput,
    updateQuote,
    updateOrder,
    showError,
    hideError,
    onBehalfOfPartnerMachineName,
    systemType,
  } = useFormContext();

  return (
    <Switch>
      <Redirect exact from="/" to={`/${HVAC_MONITORING}`} />
      <Route path={`/${HVAC_MONITORING}/:partnerOrderId?`} render={props => {
        const { partnerOrderId } = props.match.params;

        return !isEmpty(order) && partnerOrderId != null ?
          <Redirect to={`/confirmation/${partnerOrderId}`} /> :
          <Maintenance
            service={service}
            user={user}
            address={address}
            isLoading={isLoading}
            errorMessage={errorMessage}
            startLoading={startLoading}
            stopLoading={stopLoading}
            updateFormInput={updateFormInput}
            updateQuote={updateQuote}
            showError={showError}
            hideError={hideError}
            systemType={systemType}
            {...props}
          />
        }
      } />
      <Route path="/checkout/:partnerOrderId?" render={props => {
        const { partnerOrderId } = props.match.params;

        return isEmpty(quote) ?
          <Redirect
            to={{
              pathname: partnerOrderId ? `/${HVAC_MONITORING}/${partnerOrderId}` : `/${HVAC_MONITORING}`,
              search: props.location.search,
            }}
          /> :
          <Checkout
            service={service}
            user={user}
            address={address}
            quote={quote}
            isLoading={isLoading}
            errorMessage={errorMessage}
            onBehalfOfPartnerMachineName={onBehalfOfPartnerMachineName}
            startLoading={startLoading}
            stopLoading={stopLoading}
            updateFormInput={updateFormInput}
            updateOrder={updateOrder}
            showError={showError}
            hideError={hideError}
            systemType={systemType}
            {...props}
          />
        }
      } />
      <Route path="/confirmation/:partnerOrderId" render={props => {
        const { partnerOrderId } = props.match.params;

        return isEmpty(order) ?
          <Redirect
            to={{
              pathname: partnerOrderId ? `/${HVAC_MONITORING}/${partnerOrderId}`: `/${HVAC_MONITORING}`,
              search: props.location.search
            }}
          /> :
          <Confirmation
            quote={quote}
            order={order}
            service={service}
            systemType={systemType}
            {...props}
          />
        }
      } />
    </Switch>
  );
}

export default Routes;
